import proj1 from "../assets/proj1.png";
import proj2 from "../assets/proj2.png";
import proj3 from "../assets/proj3.png";

const ProjectCardData = [
    {
        imgsrc: proj1,
        title: "Basic Portfolio",
        text:"My first portfolio website created using ReactJS,Used FavIcons, Deployed on firebase. Also It is Fully Responsive. In this, we can see all my professional information ",
        proj_url:"https://kishanportfolio-815e3.web.app/",
        source_url:"https://github.com/Kishan28Kumar/kishanportfolio"
    },
    {
        imgsrc: proj2,
        title: "Text Manipulator",
        text:"Text manipulating tool build using ReactJS and Bootstrap, Fully Responsive, Deployed on Netlify.They can see pop up notification on the top about each manipulation.",
        proj_url:"https://text-manipulation.netlify.app/",
        source_url:"https://text-manipulation.netlify.app/"
    },
    {
        imgsrc: proj3,
        title: "Notes Keeping App",
        text:"Created using ReactJs. In this, Users can take notes of anything with Title and Content , They can add and delete any notes. Its a fully responsive website.",
        proj_url:"https://7kbkbz.csb.app/",
        source_url:"https://codesandbox.io/s/keeper-part-3-completed-7kbkbz"

    },
]


export default ProjectCardData;